import { createApp } from "vue";
import App from "./App.vue";
import "./styles/reset.css";
import "./styles/theme.css";

createApp(App).mount("#app");
